import { Link } from "react-router-dom";
import { trackCallClick, trackEmailClick } from "../lib/tracking";

export default function Footer() {
  return (
    <footer className="border-t border-border bg-gradient-to-br from-slate-50/80 via-card to-slate-50/50 relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_20%,rgba(99,102,241,0.03),transparent_50%)] pointer-events-none"></div>
      <div className="container mx-auto px-4 lg:px-8 py-12 lg:py-16 relative z-10">
        <div className="max-w-6xl mx-auto">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-12">
            <div className="text-center md:text-left">
              <div className="mb-4 flex justify-center md:justify-start">
                <div className="relative w-40 h-12 lg:w-44 lg:h-14 flex-shrink-0">
                  <img src="/Certif/Logo.png" alt="Mac-Support Pro Solution" className="w-full h-full object-contain" />
                </div>
              </div>
              <p className="text-sm text-muted-foreground leading-relaxed">Votre partenaire de confiance pour la gestion et la maintenance de votre parc informatique Apple.</p>
            </div>
            <div className="text-center md:text-left">
              <h3 className="font-semibold text-foreground mb-4">Services</h3>
              <ul className="space-y-3 text-sm text-muted-foreground">
                <li><a href="/#services" className="hover:text-foreground transition-colors">Gestion du parc</a></li>
                <li><a href="/#services" className="hover:text-foreground transition-colors">Maintenance</a></li>
                <li><a href="/#services" className="hover:text-foreground transition-colors">Support 24/7</a></li>
                <li><a href="/#pricing" className="hover:text-foreground transition-colors">Tarifs</a></li>
                <li><a href="/#faq" className="hover:text-foreground transition-colors">FAQ</a></li>
              </ul>
            </div>
            <div className="text-center md:text-left">
              <h3 className="font-semibold text-foreground mb-4">Contact</h3>
              <ul className="space-y-3 text-sm text-muted-foreground">
                <li><a href="tel:+33189707560" onClick={() => trackCallClick("footer")} className="hover:text-foreground transition-colors">+33 1 89 70 75 60</a></li>
                <li><a href="mailto:contact@macsupport-solution.com" onClick={() => trackEmailClick("contact@macsupport-solution.com", "footer")} className="hover:text-foreground transition-colors">contact@macsupport-solution.com</a></li>
                <li><a href="mailto:facturation@macsupport-solution.com" onClick={() => trackEmailClick("facturation@macsupport-solution.com", "footer")} className="hover:text-foreground transition-colors">facturation@macsupport-solution.com</a></li>
                <li><a href="mailto:reclamation@macsupport-solution.com" onClick={() => trackEmailClick("reclamation@macsupport-solution.com", "footer")} className="hover:text-foreground transition-colors">reclamation@macsupport-solution.com</a></li>
              </ul>
            </div>
            <div className="text-center md:text-left">
              <h3 className="font-semibold text-foreground mb-4">Légal</h3>
              <ul className="space-y-3 text-sm text-muted-foreground">
                <li><Link to="/mentions-legales" className="hover:text-foreground transition-colors">Mentions légales</Link></li>
                <li><Link to="/politique-confidentialite" className="hover:text-foreground transition-colors">Politique de confidentialité</Link></li>
                <li><Link to="/cgv" className="hover:text-foreground transition-colors">CGV</Link></li>
                <li><Link to="/cookies" className="hover:text-foreground transition-colors">Cookies</Link></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="pt-8 border-t border-border">
          <p className="text-sm text-muted-foreground text-center">© 2026 Mac-Support Pro Solution. Tous droits réservés.</p>
        </div>
      </div>
    </footer>
  );
}
